import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import L from "leaflet";
import { Autocomplete, Chip, SvgIcon, TextField } from "@mui/material";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import { isValidNum } from "../Telemetry/Constant";
import "leaflet/dist/leaflet.css";
import {
  APP_BASE_URL_ALARM,
  app_config,
  APP_GEO_SERVER_URL,
  FAMS_API_URL,
  GET_ACTIVE_ALARMS,
  GET_AOI_FROM_STN,
  GET_PAGINATED_ALARMS,
  trimAssetName,
} from "../../Common/EndPoints";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateSelectedSidebarKey } from "../NewSidebar/sidebarSlice";
import { setTemporaryAlarmFilters, updateTemporaryAlarmFilters } from "../../features/Alarms/alarmsSlice";

import { isLoggedInSelector, selectedCustomersSelector } from "../../features/authentication/auth-slice";
import { useImmer } from "use-immer";
import axios from "axios";
import { getCables, getLatLonFromAlarmPacket } from "./unifiedAlarmDashboardConstants";
import { getLocalStorage, getParsedLocalStorage } from "../../Utils/storage-utils";
import toast from "react-hot-toast";
import { appendQueryParams, extractParsedDataFromPermissions } from "../../Utils/Utils";
import { AutocompleteStationListPop } from "../AutocompleteStationListPop/AutocompleteStationListPop";
import Loader from "../Loader/Loader";
import moment from "moment";

const map_tile_configuration = app_config?.geo_server_configuration?.map_tiles_config ?? {}
const MAX_ZOOM = map_tile_configuration?.maxZoom ?? 18




const addMapLayer = (mapInstance) => {
  const {url, query={}, other_opts={}} = map_tile_configuration?.custome_tile_options??{};
  console.log('dsahfjksab', url, query,appendQueryParams(url,query))
  if(!url){
    toast.error('Invalid map tile configurations')
    return;
  }
  const map_url = appendQueryParams(url,query);
  const map_options ={
    ...other_opts,
    maxZoom: MAX_ZOOM,
  }
  L.tileLayer(map_url, map_options).addTo(mapInstance);
};

const createMuiIcon = () => {
  const iconHtml = ReactDOMServer.renderToString(
    <SvgIcon component={FmdBadIcon} style={{ color: "red", fontSize: 32 }} />,
  );

  return L.divIcon({
    html: iconHtml,
    iconSize: [32, 32],
    className: "", // remove default Leaflet styles
  });
};
const getStrCustomerIds = (list = [], key = "customerId") => {
  return list.map((customer) => customer[key]).join(",");
};
const initData = {
  cables: null,
  alarms: [],
  bounds: null,
};

function MapFilter({ filters, setFilters }) {
  const initFilter = useMemo(() => {
    return {
      customer_ids: [],
    };
  }, []);
  const parsedPermissions = useMemo(() => {
    return extractParsedDataFromPermissions(getParsedLocalStorage("permissions"));
  }, []);

  const selectedCustomersList = useSelector(selectedCustomersSelector);

  const permittedCustomerIds = useMemo(() => {
    const _list = selectedCustomersList;
    if (!_list) return [];
    return _list.map((customer) => customer.customerId);
  }, [selectedCustomersList]);
  const customer_dd = useMemo(() => {
    let filtered_stations = parsedPermissions.stations.filter((obj) => permittedCustomerIds.includes(obj.id));

    return filtered_stations;
  }, [permittedCustomerIds]);
  return (
    <div className="gis-filters">
      <Autocomplete
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        className="gis-filter-form-item"
        options={customer_dd ?? []}
        value={filters.customer_ids || []}
        onChange={(_, newValue) => {
          setFilters("customer_ids", newValue);
        }}
        size="small"
        disableCloseOnSelect
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Stations" size="small" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
    </div>
  );
}
function UnifiedDashboardMap({ alarmSocketPacket, setFmsAlarmCnt, isFullscreen }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const parsedPermissions = useMemo(() => {
    return extractParsedDataFromPermissions(getParsedLocalStorage("permissions"));
  }, []);
  const selectedCustomersList = useSelector(selectedCustomersSelector);
  const [mapFilters, setMapFilters] = useImmer({});
  const [loader, setLoader] = useState(false);
  const [unifiedMapData, setUnifiedMapData] = useImmer(initData);
  const alarm_cnts = useMemo(() => {
    return Object.keys(unifiedMapData?.alarms ?? {})?.length ?? 0;
  }, [unifiedMapData.alarms]);
  const mapRef = useRef(null);
  const layersRef = useRef({ cables: null, asset: L.layerGroup() });

  const default_map_options = useMemo(() => {
    return {
      center: [26.523488, 77.38723],
      preferCanvas: true,
      zoom: 5,
      minZoom: 2,
      maxZoom: MAX_ZOOM,
      // maxZoom: 18,
      doubleClickZoom: false,
      attributionControl: true,
    };
  }, []);

  useEffect(() => {
    const mapInstance = mapRef.current;
    if (!mapInstance) return;

    // ----PLOT CABLE AND BOUNDS---------
    let cables = null;
    if (unifiedMapData?.cables && unifiedMapData?.cables?.features?.length) {
      cables = unifiedMapData?.cables;
    }
    const get_bound_by_alarms = Boolean(unifiedMapData?.alarms && unifiedMapData?.alarms?.length);
    const get_bound_by_cables = Boolean(!get_bound_by_alarms && cables);
    console.log("fdskgfdjgld alarm", unifiedMapData?.alarms, unifiedMapData?.alarms?.length);
    console.log("fdskgfdjgld cable", get_bound_by_alarms, cables, cables?.length);
    plotCables(cables, get_bound_by_cables);
    plotAlarmAssets(unifiedMapData?.alarms, get_bound_by_alarms);
    // getBoundsAndSetView(unifiedMapData?.alarms, cables)
  }, [unifiedMapData]);

  const getBoundsAndSetView = (alarms = [], cable) => {};

  useEffect(() => {
    if (!alarmSocketPacket) return;

    getCablesAndCableAlarms(true);
  }, [alarmSocketPacket]);

  const plotCables = (cables, boundFlag = false) => {
    const mapInstance = mapRef.current;

    // Clear previous layers
    if (layersRef.current.cables) {
      mapInstance.removeLayer(layersRef.current.cables);
      layersRef.current.cables = null;
    }
    if (layersRef.current.cableLabels) {
      mapInstance.removeLayer(layersRef.current.cableLabels);
      layersRef.current.cableLabels = null;
    }

    if (cables) {
      const cableLabelLayer = L.layerGroup();
      const cableLayer = L.geoJSON(cables, {
        style: (feature) => {
          if (feature.geometry.type === "LineString") {
            return { color: "#3399ff", weight: 3 };
          }
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === "LineString") {
            const spanName = feature.properties?.Span || "";
            const asset_id = feature.properties?.AssetId || "";
            const route = feature.properties?.Route || "";
            const gis_len = feature.properties?.["GIS Length(km)"] || "";

            // Midpoint for placing label
            const coords = feature.geometry.coordinates.map(([lon, lat]) => [lat, lon]);
            const mid = coords[Math.floor(coords.length / 2)];

            // Create a label marker
            const label = L.marker(mid, {
              icon: L.divIcon({
                className: "cable-label",
                html: `<div class="cable-text">${asset_id}</div>`,
                iconSize: [50, 20],
                iconAnchor: [40, 10],
              }),
              interactive: true,
            });

            const tooltipText = `
            <strong>Asset No:</strong> ${asset_id || "N/A"}<br/>
              <strong>Span:</strong> ${spanName}<br/>
              <strong>Route:</strong> ${route}<br/>
              <strong>GIS Length(km):</strong> ${gis_len}<br/>
            `;
            label.bindTooltip(tooltipText, {
              direction: "top",
              permanent: false,
              sticky: true,
              opacity: 0.9,
            });
            layer.bindTooltip(tooltipText, {
              direction: "top",
              permanent: false,
              sticky: true,
              opacity: 0.9,
            });

            cableLabelLayer.addLayer(label);

            // Tooltip on click
          }
        },
      });

      layersRef.current.cables = cableLayer;
      layersRef.current.cableLabels = cableLabelLayer;

      // Add to map
      cableLayer.addTo(mapInstance);
      cableLabelLayer.addTo(mapInstance);
      if (boundFlag) {
        const bounds = cableLayer.getBounds();
        mapInstance.flyToBounds(bounds, {
          padding: [18, 18],
          duration: 1.5,
        });
      }
    }
  };

  const plotAlarmAssets = (alarms = [], boundFlag = false) => {
    // debugger;
    const mapInstance = mapRef.current;
    layersRef?.current?.asset?.clearLayers();
    const icon = createMuiIcon();
    const total_geom = [];
    console.log("alarms", alarms);
    alarms.forEach((alarm) => {
      total_geom.push(alarm.geometry);
      const marker = L.marker(alarm.geometry, { icon });
      const popupContent = L.DomUtil.create("div", "");
      popupContent.innerHTML = `
        <strong>${alarm.device_name}</strong><br/>
        <div>Asset Type: ${alarm.device_type ?? ""}</div>
        <div>Alarm Type: ${alarm.alarm_type ?? ""}</div>
        <div>Severity: ${alarm.severity ?? ""}</div>
        <div>Created At: ${alarm.created_dt ?? ""}</div>
        <div>Updated At: ${alarm.updated_dt ?? ""}</div>
        <a href="#" class="alarm-link">Redirect to alarm</a>
      `;

      setTimeout(() => {
        const link = popupContent.querySelector(".alarm-link");
        link?.addEventListener("click", (e) => {
          e.preventDefault();
          const params = {
            device_ids: [{ id: alarm.device_id, value: alarm.device_name }],
            deviceNamesList: [{ id: alarm.device_id, value: alarm.device_name }],
            limit: 20,
            offset: 0,
            is_active: true,
          };

          dispatch(updateSelectedSidebarKey("ALARM"));
          dispatch(updateTemporaryAlarmFilters(params));
          navigate("/alarms");
          // Add your redirect logic here
        });
      }, 0);

      marker.bindPopup(popupContent);
      marker.addTo(layersRef.current.asset);
    });

    if (total_geom.length && boundFlag) {
      const bounds = L.latLngBounds(total_geom);
      mapInstance.flyToBounds(bounds, {
        padding: [50, 50],
        duration: 1.5,
      });
    }
  };

  useEffect(() => {
    if (!selectedCustomersList.length) return;

    getCablesAndCableAlarms();
  }, [selectedCustomersList, mapFilters.customer_ids]);

  useEffect(() => {
    if (mapRef.current) {
      setTimeout(() => {
        mapRef.current.invalidateSize();
      }, 300); // Small delay to allow for CSS transitions
    }
  }, [isFullscreen]);

  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = L.map("map", {
        ...default_map_options,
      });
      addMapLayer(mapRef.current);

      // addSetteliteLayer(mapRef.current);
      layersRef.current.asset.addTo(mapRef.current);
    }

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  const getCablesAndCableAlarms = async (silent_update) => {
    const str_customer_ids = mapFilters.customer_ids?.length
      ? getStrCustomerIds(mapFilters.customer_ids, "id")
      : getStrCustomerIds(selectedCustomersList);

    const str_stn_list = parsedPermissions.stations
      .filter((obj) => str_customer_ids.includes(obj.id))
      ?.map((stn) => stn.value)
      .join();
    const user_id = getLocalStorage("userId");

    // Fetch CABLES
    // alarms
    // Fetch AOIS
    if (!silent_update) {
      setLoader(true);
    }

    let cables = null;
    let alarm_list = [];
    try {
      let aoi_mapping_url = `${FAMS_API_URL}${GET_AOI_FROM_STN}?stnList=${str_stn_list}&userId=${user_id}`;
      const aoi_list_res = await fetch(aoi_mapping_url);
      if (!aoi_list_res.ok) {
        throw new Error(`Fetch failed with status ${aoi_list_res.status}`);
      }

      const aoi_response = await aoi_list_res.json();
      if (!aoi_response?.length) {
        throw new Error(`No AOI Found for given customers`);
      }
      let aoi_list = aoi_response.map((item) => `'${item.id}'`).join(",");
      const cable_fetch_params = {
        service: "WFS",
        version: "1.0.0",
        request: "GetFeature",
        typeName: "geonet:Cable",
        outputFormat: "application/json",
        CQL_FILTER: `aoiid IN (${aoi_list})`,
      };
      const queryString = new URLSearchParams(cable_fetch_params).toString();
      const response = await fetch(`${APP_GEO_SERVER_URL}?${queryString}`);

      if (!response.ok) {
        throw new Error(`Fetch failed with status ${response.status}`);
      }
      cables = await response.json();
    } catch (err) {
      toast.error(err.message);
      cables = null;
    }

    try {
      const fms_system_obj = getParsedLocalStorage("systems_list", [])?.find(
        (sys) => sys.code === "FMS" || sys.code === "FAMS",
      );
      if (fms_system_obj) {
        const alarm_params = {
          customer_ids: str_customer_ids,
          with_device: true,
          with_device_type: true,
          with_software: true,
          // software_ids: fms_system_obj.id,
        };
        const url = `${APP_BASE_URL_ALARM}${GET_ACTIVE_ALARMS}`;
        const fams_alarms = await axios.get(url, { params: alarm_params });

        let alarms_data = fams_alarms?.data ?? [];

        alarms_data.forEach((alarm) => {
          const device = alarm.device;
          if (!device) return;
          const device_name = trimAssetName(device.name ?? "");
          if (!device_name) return;
          const geom = getLatLonFromAlarmPacket(alarm);

          if (!geom) return;
          const entry = {
            device_id: alarm.device_id,
            device_name,
            device_type: device.device_type?.label,
            alarm_type: alarm.type,
            severity: alarm.severity,
            geometry: geom,
            created_dt: moment(alarm.created_dt).format("DD-MM-YYYY HH:mm:ss"),
            updated_dt: alarm.updated_dt ? moment(alarm.updated_dt).format("DD-MM-YYYY HH:mm:ss") : "NA",
          };
          alarm_list.push(entry);
        });
      } else {
        throw new Error("Unable to fetch FMS alarms as FMS system is not assigned");
      }
    } catch (err) {
      toast.error(err.message);
      alarm_list = [];
    }

    setUnifiedMapData((prev) => {
      prev.alarms = alarm_list;
      prev.cables = cables;
    });
    setFmsAlarmCnt(alarm_list?.length ?? 0);
    setLoader(false);
  };

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <div className="map-header">
        <MapFilter
          filters={mapFilters}
          setFilters={(filterKey, filterValue) => {
            setMapFilters((prev) => {
              prev[filterKey] = filterValue;
            });
          }}
        />
      </div>
      <div id="map" style={{ width: "100%", height: "100%" }}></div>;{loader && <Loader />};
    </div>
  );
}

export default UnifiedDashboardMap;
